import type { ConnectedProjectDto } from "@/api/types";

/** Explicit selections never fall back to a different project. Portfolio routes reuse the last valid selection. */
export function resolveProject(
  projects: ConnectedProjectDto[],
  selection: { projectId?: string; slug?: string; recentProjectId?: string },
): ConnectedProjectDto | undefined {
  if (selection.projectId) {
    return projects.find((project) => project.id === selection.projectId);
  }
  if (selection.slug) {
    return projects.find((project) => project.slug === selection.slug);
  }

  return (
    projects.find((project) => project.id === selection.recentProjectId) ??
    projects.reduce<ConnectedProjectDto | undefined>(
      (first, project) => (!first || project.name < first.name ? project : first),
      undefined,
    )
  );
}
